"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _4d_mapper_1 = require("4d-mapper");
const operators_1 = require("rxjs/operators");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const Cesium = window.Cesium;
/**
 * an implmentation speicifc coordinate. Contains untis to convert from cesium to standard coords
 * as well as placeholders for holding the cesium cartesian coords so they dont need to be recalced
 */
class PinAnnotationRenderer extends _4d_mapper_1.LegacyAnnotationRenderer {
    onUpdate(obj, pr, args) {
        return super.onUpdate(obj, pr, args).pipe(operators_1.tap(res => res.object.pin.billboard.image = this.getPinImage(res.plottable)));
    }
    /*
         Static pin helpers
     */
    getPinImage(annotation, pinColor) {
        if (!annotation)
            return;
        var icon = this.getPinIcon(annotation);
        return this.getPinSvg(icon, pinColor ? pinColor : annotation['color'] || 'blue');
    }
    getPinSvg(icon, pinColor = 'red', size = 45) {
        var iconZ = pro_solid_svg_icons_1.fas[icon] || pro_solid_svg_icons_1.fas[Object.keys(pro_solid_svg_icons_1.fas).find(k => pro_solid_svg_icons_1.fas[k].iconName == icon)];
        return 'data:image/svg+xml;base64,' + window['btoa']('<svg aria-hidden="true" data-prefix="fas" data-icon="tags" role="img" xmlns="http://www.w3.org/2000/svg" height="' + size + '" width="' + size + '" viewBox="0 0 640 517">' +
            '<path fill="' + pinColor + '" d="' + iconZ.icon[4] + '"></path></svg>');
    }
    getPinIcon(annotation) {
        return Object.keys(pro_solid_svg_icons_1.fas).find(k => pro_solid_svg_icons_1.fas[k].iconName == (annotation['icon'] || 'map-marker-alt'));
    }
}
exports.PinAnnotationRenderer = PinAnnotationRenderer;
